import React from 'react';
import { useNavigate } from "react-router-dom";
import './AdminView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUser, faPrint, faUserFriends, faBattery, faLightbulb, faBolt, faPassport, faBars, faAdd, faGears } from '@fortawesome/free-solid-svg-icons';

const AdminView = () => {
    const navigate = useNavigate();

    return (
        <div className="admin-view-container">
            <h1 className="title">Hola, Administrador</h1>
            <p className="description">¿Qué deseas hacer?</p>
            <div className="admin-view-options">
                {/* <button onClick={() => navigate('/admin/ciudades')}><FontAwesomeIcon icon={faGears} /> Ciudades</button> */}
                <button onClick={() => navigate('/admin/ciudades/settings')}><FontAwesomeIcon icon={faGears} /> Ciudades</button>
                {/* <button onClick={() => navigate('/admin/estados')}><FontAwesomeIcon icon={faAdd} /> Estados</button>*/}
                <button onClick={() => navigate('/admin/estados/settings')}> <FontAwesomeIcon icon={faGears} /> Estados</button>
                {/* <button onClick={() => navigate('/admin/baterias')}><FontAwesomeIcon icon={faBattery} /> Baterías</button>*/}
                <button onClick={() => navigate('/admin/baterias/settings')}><FontAwesomeIcon icon={faGears} /> Baterías</button>
                {/* <button onClick={() => navigate('/admin/controladores')}><FontAwesomeIcon icon={faBolt} /> Controladores</button>*/}
                <button onClick={() => navigate('/admin/controladores/settings')}><FontAwesomeIcon icon={faGears} /> Controladores</button>
                {/* <button onClick={() => navigate('/admin/inversores')}><FontAwesomeIcon icon={faLightbulb} /> Inversores</button>*/}
                <button onClick={() => navigate('/admin/inversores/settings')}><FontAwesomeIcon icon={faGears} /> Inversores</button>
                {/* <button onClick={() => navigate('/register')}><FontAwesomeIcon icon={faUserFriends} /> Usuarios</button> */}
                <button onClick={() => navigate('/admin/users/settings')}><FontAwesomeIcon icon={faGears} /> Usuarios</button>
                <button onClick={() => navigate('/home')}>Salir</button>
            </div>
        </div>
    );
};

export default AdminView;